import styles from '../TermsOfService/TermsOfService.module.css';

export default function PrivacyPolicy() {
    return (
        <div className={styles.background}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <span className={styles.header}>Privacy Policy</span>
                    Last Updated: Apr 25, 2024
                    <p>
                        This Privacy Policy describes how StellarFX Labs Inc.
                        d/b/a StellarFX (&quot;
                        <span style={{ fontWeight: 'bold' }}>StellarFX</span>
                        ,&quot; &quot;
                        <span style={{ fontWeight: 'bold' }}>we</span>&quot;, “
                        <span style={{ fontWeight: 'bold' }}>us</span>” or
                        &quot;<span style={{ fontWeight: 'bold' }}>our</span>
                        &quot;) processes personal information that we collect
                        through our digital or online properties or services
                        that link to this Privacy Policy (the “
                        <span style={{ fontWeight: 'bold' }}>
                            Service
                        </span>”).{' '}
                    </p>
                    <p className={styles.sub_header}>
                        Personal information we collect
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Information you provide to us.
                        </span>{' '}
                        Personal information you may provide to us through the
                        Service or otherwise includes:
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Contact data
                            </span>
                            , such as your first and last name, email address,
                            and country of residence.
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Profile data
                            </span>
                            ,such as your cryptocurrency wallet and associated
                            details (such as stored value and wallet address),
                            gas costs, public on-chain data, Discord ID,
                            username or password used to establish an online
                            account on the Service, and any other information
                            that you add to your account profile.&nbsp;{' '}
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Communications data{' '}
                            </span>
                            based on our exchanges with you and with other users
                            of the Services (such as when you use our public
                            forum), including when you contact us through the
                            Service.{' '}
                        </li>

                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Transactional data
                            </span>
                            , such as information relating to or needed to
                            complete your exchanges on or through the Service,
                            including type of cryptocurrency traded and
                            transaction history.{' '}
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Marketing data
                            </span>
                            , such as your preferences for receiving our
                            marketing communications and details about your
                            engagement with them.
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Other data{' '}
                            </span>
                            not specifically listed here, which we will use as
                            described in this Privacy Policy or as otherwise
                            disclosed at the time of collection.
                        </li>
                    </ul>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Third-party sources.
                        </span>{' '}
                        We may combine personal information we receive from you
                        with personal information that we obtain from other
                        sources, such as such as public records and public
                        blockchains, which may include blockchain addresses and
                        information regarding purchases, sales, or transfers of
                        cryptocurrency.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Automatic data collection.
                        </span>{' '}
                        We, our service providers, and our business partners may
                        automatically log information about you, your computer
                        or mobile device, and your interaction over time with
                        the Service, our communications and other online
                        services, such as:
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Device data
                            </span>
                            ,such as your computer or mobile device’s operating
                            system type and version, manufacturer and model,
                            browser type, screen resolution, RAM and disk size,
                            CPU usage, device type (e.g., phone, tablet), IP
                            address, unique identifiers, language settings,
                            mobile device carrier, radio/network information
                            (e.g., Wi-Fi, LTE, 3G), and general location
                            information such as city, state or geographic area.
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Online activity data
                            </span>
                            , such as pages or screens you viewed, how long you
                            spent on a page or screen, the website you visited
                            before browsing to the Service, navigation paths
                            between pages or screens, information about your
                            activity on a page or screen, access times and
                            duration of access, and whether you have opened our
                            emails or clicked links within them.
                        </li>
                    </ul>
                    <p className={styles.sub_header}>Tracking Technologies</p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Cookies and similar technologies.
                        </span>{' '}
                        Some of the automatic collection described above is
                        facilitated by the following technologies:
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>Cookies</span>,
                            which are small text files that websites store on
                            user devices and that allow web servers to record
                            users’ web browsing activities and remember their
                            submissions, preferences, and login status as they
                            navigate a site. Cookies may include both “session
                            cookies” that are deleted when a session ends,
                            “persistent cookies” that remain longer, “first
                            party” cookies that we place and “third party”
                            cookies that our third-party business partners and
                            service providers’ place.{' '}
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Local storage technologies
                            </span>
                            , like HTML5, that provide cookie-equivalent
                            functionality but can store larger amounts of data
                            on your device outside of your browser in connection
                            with specific applications.{' '}
                        </li>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Web beacons
                            </span>
                            , also known as pixel tags or clear GIFs, which are
                            used to demonstrate that a webpage or email was
                            accessed or opened, or that certain content was
                            viewed or clicked.{' '}
                        </li>
                    </ul>
                    <p className={styles.sub_header}>
                        How we use your personal information
                    </p>
                    <p>
                        We may use your personal information for the following
                        purposes or as otherwise described at the time of
                        collection:
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Service delivery and operations.
                        </span>{' '}
                        We may use your personal information to:
                    </p>
                    <ul>
                        <li>provide the Service;</li>
                        <li>enable security features of the Service;</li>
                        <li>conduct OFAC and similar checks;</li>
                        <li>
                            communicate with you about the Service, including by
                            sending Service-related announcements, updates,
                            security alerts, and support and administrative
                            messages; and
                        </li>
                        <li>
                            provide support for the Service, and respond to your
                            requests, questions and feedback.
                        </li>
                    </ul>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Service personalization
                        </span>
                        , which may include using your personal information to:
                    </p>
                    <ul>
                        <li>understand your needs and interests;</li>
                        <li>
                            personalize your experience with the Service and our
                            Service-related communications; and
                        </li>
                        <li>
                            remember your selections and preferences as you
                            navigate webpages.
                        </li>
                    </ul>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>Marketing.</span>{' '}
                        We and our service providers may collect and use your
                        personal information to send you direct marketing
                        communications and may personalize these messages based
                        on your needs and interests. You may opt-out of our
                        marketing communications as described in the Opt-out of
                        communications section below.&nbsp;{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Compliance and protection.
                        </span>{' '}
                        We may use your personal information to:
                    </p>
                    <ul>
                        <li>
                            comply with applicable laws, lawful requests, and
                            legal process, such as to respond to subpoenas,
                            investigations or requests from government
                            authorities;
                        </li>
                        <li>
                            protect our, your or others’ rights, privacy, safety
                            or property (including by making and defending legal
                            claims);{' '}
                        </li>
                        <li>
                            audit our internal processes for compliance with
                            legal and contractual requirements or our internal
                            policies;{' '}
                        </li>
                        <li>
                            enforce the terms and conditions that govern the
                            Service; and{' '}
                        </li>
                        <li>
                            prevent, identify, investigate and deter fraudulent,
                            harmful, unauthorized, unethical or illegal
                            activity, including cyberattacks and identity
                            theft.&nbsp;
                        </li>
                    </ul>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Research and development
                        </span>
                        .&nbsp; We may use your personal information to analyze
                        and improve the Service and our business.&nbsp; As part
                        of these activities, we may create aggregated,
                        de-identified or other anonymous data from personal
                        information we collect.&nbsp; We make personal
                        information into anonymous data by removing information
                        that makes the data personally identifiable to
                        you.&nbsp; We may use this anonymous data and share it
                        with third parties for our lawful business purposes,
                        including to analyze and improve the Service and promote
                        our business.&nbsp;&nbsp;{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Cookies and similar technologies.
                        </span>{' '}
                        In addition to the other uses included in this section,
                        we may use the Cookies and similar technologies
                        described above for the following purposes:
                    </p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Technical operation
                            </span>
                            . To allow the technical operation of the Service,
                            such as by remembering your selections and
                            preferences as you navigate the site, and whether
                            you are logged in if you visit password protected
                            areas of the Service.
                        </li>

                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Functionality
                            </span>
                            . To enhance the performance and functionality of
                            our services.
                        </li>

                        <li>
                            <span style={{ fontWeight: 'bold' }}>
                                Analytics
                            </span>
                            . To help us understand user activity on the
                            Service, including which pages are most and least
                            visited and how visitors move around the Service, as
                            well as user interactions with our emails. For
                            example, we use Plausible for this purpose. You can
                            learn more about Plausible here: &nbsp;
                            <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href='https://plausible.io/docs/excluding'
                            >
                                www.plausible.io/docs/excluding
                            </a>
                            .{' '}
                        </li>
                    </ul>
                    <p className={styles.sub_header}>
                        How we share your personal information
                    </p>
                    <p>
                        We may share your personal information with the
                        following parties and as otherwise described in this
                        Privacy Policy, in other applicable notices, or at the
                        time of collection.&nbsp;{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>Affiliates. </span>
                        Our corporate parent, subsidiaries, and affiliates.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Service providers.
                        </span>{' '}
                        Third partiesthat provide services on our behalf or help
                        us operate the Service or our business (such as hosting,
                        transaction relayers, information technology, customer
                        support, email delivery, marketing, consumer research
                        and website analytics).{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Third parties designated by you.{' '}
                        </span>
                        We may share your personal information with third
                        parties where you have instructed us or provided your
                        consent to do so.
                        <span style={{ fontWeight: 'bold' }}></span>
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Professional advisors.
                        </span>{' '}
                        Professional advisors, such as lawyers, auditors,
                        bankers and insurers, where necessary in the course of
                        the professional services that they render to us.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Authorities and others.{' '}
                        </span>
                        Law enforcement, government authorities, and private
                        parties, as we believe in good faith to be necessary or
                        appropriate for the Compliance and protection purposes
                        described above.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Business transferees
                        </span>
                        . We may disclose personal information in the context of
                        actual or prospective business transactions (
                        <i>e.g.,</i> investments in StellarFX, financing of
                        StellarFX, public stock offerings, or the sale, transfer
                        or merger of all or part of our business, assets or
                        shares), for example, we may need to share certain
                        personal information with prospective counterparties and
                        their advisers. We may also disclose your personal
                        information to an acquirer, successor, or assignee of
                        StellarFX as part of any merger, acquisition, sale of
                        assets, or similar transaction, and/or in the event of
                        an insolvency, bankruptcy, or receivership in which
                        personal information is transferred to one or more third
                        parties as one of our business assets.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Other users and the public.{' '}
                        </span>
                        Your profile and other data may be visible to other
                        users of the Service and the public, including through
                        public blockchains. This information can be seen,
                        collected and used by others, including being cached,
                        copied, screen captured or stored elsewhere by others
                        (e.g., search engines), and we are not responsible for
                        any such use of this information.
                    </p>
                    <p className={styles.sub_header}>Your choices </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Access or update your information.
                        </span>
                        If you have registered for an account with us through
                        the Service, you may review and update certain account
                        information by logging into the account.{' '}
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Opt-out of communications.
                        </span>{' '}
                        You may opt-out of marketing-related emails by following
                        the opt-out or unsubscribe instructions at the bottom of
                        the email, or by contacting us. Please note that if you
                        choose to opt-out of marketing-related emails, you may
                        continue to receive service-related and other
                        non-marketing emails.&nbsp;
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>Cookies</span>.
                        Most browsers let you remove or reject cookies. To do
                        this, follow the instructions in your browser settings.
                        Many browsers accept cookies by default until you change
                        your settings. Please note that if you set your browser
                        to disable cookies, the Service may not work properly.
                        For more information about cookies, including how to see
                        what cookies have been set on your browser and how to
                        manage and delete them, visit{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://www.allaboutcookies.org'
                        >
                            www.allaboutcookies.org
                        </a>
                        . You can also configure your device to prevent images
                        from loading to prevent web beacons from functioning.
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Do Not Track.
                        </span>{' '}
                        Some Internet browsers may be configured to send “Do Not
                        Track” signals to the online services that you visit. We
                        currently do not respond to “Do Not Track” signals. To
                        find out more about “Do Not Track,” please visit{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='https://www.allaboutdnt.com'
                        >
                            www.allaboutdnt.com
                        </a>
                        .
                    </p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>
                            Declining to provide information.
                        </span>{' '}
                        We need to collect personal information to provide
                        certain services. If you do not provide the information
                        we identify as required or mandatory, we may not be able
                        to provide those services.
                    </p>
                    <p className={styles.sub_header}>
                        Other sites and services
                    </p>
                    <p>
                        The Service may contain links to websites, mobile
                        applications, and other online services operated by
                        third parties. In addition, our content may be
                        integrated into web pages or other online services that
                        are not associated with us. These links and integrations
                        are not an endorsement of, or representation that we are
                        affiliated with, any third party. We do not control
                        websites, mobile applications or online services
                        operated by third parties, and we are not responsible
                        for their actions. We encourage you to read the privacy
                        policies of the other websites, mobile applications and
                        online services you use.
                    </p>
                    <p className={styles.sub_header}>Security </p>
                    <p>
                        We employ technical, organizational and physical
                        safeguards designed to protect the personal information
                        we collect. However, security risk is inherent in all
                        internet and information technologies and we cannot
                        guarantee the security of your personal information.{' '}
                    </p>
                    <p className={styles.sub_header}>
                        International data transfer
                    </p>
                    <p>
                        We are headquartered in the United States and may use
                        service providers that operate in other countries. Your
                        personal information may be transferred to the United
                        States or other locations where privacy laws may not be
                        as protective as those in your state, province, or
                        country.&nbsp;{' '}
                    </p>
                    <p className={styles.sub_header}>Children&nbsp; </p>
                    <p>
                        The Service is not intended for use by anyone under 16
                        years of age. If you are a parent or guardian of a child
                        from whom you believe we have collected personal
                        information in a manner prohibited by law, please
                        contact us. If we learn that we have collected personal
                        information through the Service from a child without the
                        consent of the child’s parent or guardian as required by
                        law, we will comply with applicable legal requirements
                        to delete the information.
                    </p>
                    <p className={styles.sub_header}>
                        Changes to this Privacy Policy{' '}
                    </p>
                    <p>
                        We reserve the right to modify this Privacy Policy at
                        any time. If we make material changes to this Privacy
                        Policy, we will notify you by updating the date of this
                        Privacy Policy and posting it on the Service or other
                        appropriate means. Any modifications to this Privacy
                        Policy will be effective upon our posting the modified
                        version (or as otherwise indicated at the time of
                        posting). In all cases, your use of the Service after
                        the effective date of any modified Privacy Policy
                        indicates your acknowledging that the modified Privacy
                        Policy applies to your interactions with the Service and
                        our business.
                    </p>
                    {/* <p className={styles.sub_header}>How to contact us</p>
                    <p>
                        <span style={{ fontWeight: 'bold' }}>Email</span>:{' '}
                        <a
                            target='_blank'
                            rel='noopener noreferrer'
                            href='mailto:info@stellarfx.org'
                        >
                            info@stellarfx.org
                        </a>
                        &nbsp;
                    </p>
                    <p>&nbsp;</p> */}
                </div>
            </div>
        </div>
    );
}
